<div class="content">
    <div class="content">
     <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 common_title">
          <h2>
            EDIT - ANIMAL DIAGNOSTIC DETAIL
            </h2>
         <!-- <p>Edit animal diagnostic detail</p>-->
          <!--<a (click)="backnavigate()"  class="back_to"><i class="fa fa-chevron-left" aria-hidden="true"></i>
           Back
          </a>-->
          </div>
      </div>
      <br>
       <form class="row">
          <div class="col-lg-4 col-md-6 col-sm-6">
            <div class="form-group">
              <label for="Species Name" >Diagnostic Test Name</label>
              <input type="text" id="Diagnostictest" name="Diagnostictest"  class="form-control">
              </div>
           </div>
       <div class="col-lg-4 col-md-6 col-sm-6">
        <div class="form-group">
          <label for="Species Name" >Date Of Test</label>
          <input type="date" name="Dateoftest" id="Dateoftest"  value="" class="form-control">
          </div>
       </div>
       <div class="col-lg-4 col-md-6 col-sm-6">
        <div class="form-group">
          <label for="Species Name" >Description</label>
          <textarea id="Description" name="Description" class="form-control"></textarea>
       </div>
    </div>
       <div class="col-lg-12 col-md-12 col-sm-12 text-center">
        <button type="submit" class="btn btn-fill btn-primary mb-3"  (click)="AnimalDiagnostic()">Submit<div class="ripple-container"></div></button>
        <button  (click)="backnavigate()" class="btn btn-fill btn-default">Cancel<div class="ripple-container"></div></button>
        </div>
       </form>
      
     </div>
   </div>
  </div>
  
  

